module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABdUExURQAAAJwIF4wHFL2DAsOWAJcIFsmaAMUKHbEJGrYKG8OHA9GWPNWwWpQ9DZh4haRjK8YLHv7DAPerA//EAPS7A8ijH9GIC5xVFcOGSdumCcFfEbJ0KryMeaOXPXtDJJmVtokAAAAPdFJOUwCZcJmZmZn+u7uZ/v7+/rMxJHcAAAB2SURBVCjPvZHdCoAgDIWXZf+F5tTK6v0fM8uIgnnRTR8bHBiHjTOAH2AVCQMuCnGV71snwAuSJO5IB5IaMnmAOKF8kkOmpFI4WWvQK69D5cGhTbe0mnA089Yvo3w7zoGxdqYGWjtn1veO6LnxSD5nxUoS9sfLdyJRFIdZT6ZyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/es.png
// module id = CtrT
// module chunks = 1